import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import SearchFiltersRecap from 'assets/themes/vacances-campings/js/module/search-filters-recap'
import type SidePanel from '@design/objects/side-panel/twig/assets'

export default function (): void {
  SearchFiltersRecap(
    document.getElementById('filters-sort') as HTMLElement,
    '#filters-sort input[name^="filter_offers"]:not([name="filter_offers[budgets]"])',
    null,
    function (el) {
      const sidePanelEl = document.getElementById('search-filters-side-panel')

      if (!sidePanelEl) {
        return
      }

      const sidePanel = ElementPropertiesManager.getProperty<SidePanel>(sidePanelEl, 'sidePanel')

      if (!sidePanel) {
        return
      }

      sidePanel.open()

      if (!el || el.getAttribute('data-type') === 'search') {
        sidePanelEl.querySelector<HTMLElement>('.tab__item[data-target="search"]')?.click()
      }

      if (el && el.getAttribute('data-type') === 'filters') {
        sidePanelEl.querySelector<HTMLElement>('.tab__item[data-target="filters"]')?.click()
      }
    }
  )
}
